import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="bg-[#0F3D22] text-white">
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">

        {/* Brand */}
        <div className="lg:col-span-2">
          <img
            src="/images/greenly.png"
            alt="Greenly Electronics Recycling Los Angeles"
            className="h-12 w-auto object-contain mb-4"
            loading="lazy"
          />
          <p className="text-green-200 text-sm leading-relaxed mb-3">
            Los Angeles&apos; hometown certified e-waste recycler. Proudly serving the communities of LA County since 2010 — protecting your data and our planet.
          </p>
          <div className="flex items-center gap-1.5 text-green-300 text-xs mb-4">
            <i className="ri-map-pin-2-fill text-[#4CAF82]"></i>
            2542 W. 3rd Street, Los Angeles, CA 90057
          </div>
          <div className="flex items-center gap-3">
            {[
              { icon: 'ri-facebook-fill', href: '#' },
              { icon: 'ri-twitter-x-fill', href: '#' },
              { icon: 'ri-linkedin-fill', href: '#' },
              { icon: 'ri-instagram-line', href: '#' },
            ].map((s) => (
              <a
                key={s.icon}
                href={s.href}
                rel="nofollow"
                className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-[#4CAF82] transition-colors cursor-pointer"
                aria-label={s.icon}
              >
                <i className={`${s.icon} text-sm`}></i>
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 id="footer-links" className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">
            <a href="#footer-links">Our Services</a>
          </h4>
          <ul className="space-y-2.5">
            {[
              { label: 'Blog & Resources', path: '/blog' },
              { label: 'E-Waste Guide', path: '/e-waste-guide' },
              { label: 'Business Sustainability', path: '/sustainability-report' },
              { label: 'Electronics Recycling', path: '/services' },
              { label: 'TV Recycling Los Angeles', path: '/tv-recycling' },
              { label: 'Computer Recycling LA', path: '/computer-recycling' },
              { label: 'Battery Recycling LA', path: '/battery-recycling' },
              { label: 'EV Charger Recycling LA', path: '/ev-charging-recycling' },
              { label: 'Hard Drive Destruction', path: '/hard-drive-destruction' },
              { label: 'Drop-Off Locations', path: '/locations' },
              { label: 'W 3rd Street Location', path: '/locations/west-3rd-street' },
              { label: 'Slauson Ave Location', path: '/locations/slauson-ave' },
              { label: 'Service Areas', path: '/service-areas' },
              { label: 'E-Waste Events', path: '/events' },
              { label: 'Items We Recycle', path: '/faq' },
              { label: 'About Us', path: '/about' },
              { label: 'Reviews', path: '/reviews' },
              { label: 'Contact Us', path: '/contact' },
              { label: 'Sitemap', path: '/sitemap' },
            ].map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="text-green-200 text-sm hover:text-white transition-colors cursor-pointer">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Service Areas */}
        <div>
          <h4 id="footer-areas" className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">
            <a href="#footer-areas">Service Areas</a>
          </h4>
          <ul className="space-y-2">
            {[
              'Downtown Los Angeles',
              'Hollywood & Silver Lake',
              'Santa Monica & Venice',
              'Burbank & Glendale',
              'Pasadena & SGV',
              'Long Beach',
              'South Bay & Harbor',
              'San Fernando Valley',
              'Culver City & West LA',
              'Inglewood & Hawthorne',
            ].map((area) => (
              <li key={area} className="flex items-center gap-1.5">
                <i className="ri-map-pin-line text-[#4CAF82] text-xs shrink-0"></i>
                <span className="text-green-200 text-xs">{area}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 id="footer-contact" className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">
            <a href="#footer-contact">Contact Info</a>
          </h4>
          <ul className="space-y-3.5">
            <li className="flex gap-3 items-center">
              <div className="w-5 h-5 flex items-center justify-center shrink-0">
                <i className="ri-phone-line text-[#4CAF82]"></i>
              </div>
              <a href="tel:+12136001000" className="text-green-200 text-sm hover:text-white transition-colors cursor-pointer">
                (213) 600-1000
              </a>
            </li>
            <li className="flex gap-3 items-center">
              <div className="w-5 h-5 flex items-center justify-center shrink-0">
                <i className="ri-mail-line text-[#4CAF82]"></i>
              </div>
              <a href="mailto:info@greenly.us" className="text-green-200 text-sm hover:text-white transition-colors cursor-pointer">
                info@greenly.us
              </a>
            </li>
            <li className="flex gap-3 items-start">
              <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                <i className="ri-time-line text-[#4CAF82]"></i>
              </div>
              <div className="text-green-200 text-sm leading-relaxed">
                Mon–Fri: 8:00am – 5:00pm<br />
                Sat: 9:00am – 2:00pm
              </div>
            </li>
            <li className="pt-1">
              <Link
                to="/pickup-request"
                className="inline-flex items-center gap-2 bg-[#4CAF82] hover:bg-[#74C69D] text-white text-xs font-bold px-4 py-2 rounded-md transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-calendar-check-line"></i>
                Schedule Pickup
              </Link>
            </li>
          </ul>
        </div>

      </div>
    </div>

    {/* Bottom bar */}
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-green-300 text-xs">
          &copy; {new Date().getFullYear()} Greenly Electronics Recycling — Los Angeles, CA. All rights reserved.
        </p>
        <div className="flex items-center gap-4 flex-wrap justify-center sm:justify-end">
          <Link to="/sitemap" className="text-green-300 text-xs hover:text-white transition-colors cursor-pointer">
            Sitemap
          </Link>
          <Link to="/privacy-policy" className="text-green-300 text-xs hover:text-white transition-colors cursor-pointer">
            Privacy Policy
          </Link>
          <Link to="/terms-of-service" className="text-green-300 text-xs hover:text-white transition-colors cursor-pointer">
            Terms of Service
          </Link>
          <span className="text-green-300/50 text-xs">|</span>
          <span className="text-green-300 text-xs">CalRecycle CEWD-127531</span>
          <Link to="/admin" className="text-green-400/50 text-xs hover:text-green-300 transition-colors cursor-pointer">
            Admin
          </Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
